<div id="cloud-export-input" *ngIf="ready">
  <input [(ngModel)]="url" id="cloud-export-url">
  <button id="cloud-export-nav-btn" (click)="navToUrl()"></button>

  <div id="blobToDownload" *ngIf="!!blob_url">
    {{ blob_url }}
  </div>

</div>
